export default {
  title: 'Pedido manual',
  shoppingList: 'Pedido general',
  buttons: {
    submit: 'Crear orden de compra',
    saveTemplate: 'Guardar plantilla',
    loadTemplate: 'Usar plantilla',
    addProduct: 'Agregar producto',
    xml: 'Subir factura y crear orden',
    create: 'Pedido manual',
    addProvider: 'Selecciona al proveedor',
    close: 'Cerrar',
    save: 'Guardar',
    noUpdate: 'No actualizar',
    propagatePriceToOrders: 'Actualizar órdenes',
    propagatePriceToOrdersAndProduct: 'Actualizar órdenes y producto'
  },
  labels: {
    area: 'Área'
  }
}
